"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tyCenter = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ZmapHelper = require("./util/ZmapHelper.js");

var _alarmArea = require("./business/alarmArea");

var _wind = require("./util/wind.js");

var _typhoonDom = require("./typhoonDom");

var _typhoonCities = require("./util/typhoonCities.conf");

var _typhoonCities2 = _interopRequireDefault(_typhoonCities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var helper = null;
var tyUrl = "/MeteoSyncServer/typhoon/getmsg" + ("?cacheCtrl=" + Date.now()),
    latestTyUrl = window.PAGE_CONFIG.BASE_URL + "/typhoon/info/find_Latest_ByMaxtime?&limit=3&_=" + Date.now();
var tyLayerGroup = [],
    layersGoesBack = [],
    isTyDisplay = [];

var currentTyIds = [];
var typhoonInfo = {};

var fcidColor = {
  "BABJ": "rgb(24, 92, 186)",
  "BCGZ": "#f00808",
  "RJTD": "rgb(67, 255, 75)",
  "ECMF": "#ffc107"
};

var tyCenter = exports.tyCenter = {
  0: null,
  1: null,
  2: null
};
var moveView = true;
var timer = null;

var renderTyDOM = function renderTyDOM() {
  var html = "";
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = currentTyIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var tsid = _step.value;

      html += "<li tsid=\"" + tsid + "\"><a>" + (typhoonInfo[tsid] ? typhoonInfo[tsid].tscname : "热带低压") + "</a></li>";
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  $("#tylistName ul").html(html);
  $("#tylistName ul li").eq(0).click();
};

$(".typhoonPublish").on("click", ".forecast", function () {
  $(".publishList").toggle();
  return false;
});

$("#tylistName").on("click", "li", function () {
  $(this).addClass("on").siblings("li").removeClass("on");
  var tsid = Number($(this).attr("tsid"));

  getTyForecast(tsid);
});
var getTyForecast = function getTyForecast(tsid) {
  if (typhoonInfo[tsid].real.length == 0 && typhoonInfo[tsid].fst.length == 0) {
    $(".tylist_date ul").html("");
    $("#tyTsid").text("");
    $("#tyLongitude").text("");
    $("#tyLatitude").text("");
    $("#tyWindpower").text("");
    $("#tyWindspeed").text("");
    $("#tyCenterpressure").text("");
    $("#tySevencircle").text("");
    $("#tyTencircle").text("");
  } else {
    var html = "";
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = typhoonInfo[tsid].real[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var item = _step2.value;

        var time = item.time;
        html += "<li time=\"" + time + "\" data-type=\"real\">\n                <div class=\"tylistDate_div\">\n                  <p>" + new Date(time).Format("dd") + "\u65E5</p>\n                  <p>" + new Date(time).Format("HH") + "\u65F6</p>\n                </div>\n              </li>";
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = typhoonInfo[tsid].fst[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _item = _step3.value;

        var _time = _item.time + _item.leadtime * 60 * 60 * 1000;
        html += "<li time=\"" + _time + "\" data-type=\"fst\">\n                <div class=\"tylistDate_div\">\n                  <p>" + new Date(_time).Format("dd") + "\u65E5</p>\n                  <p>" + new Date(_time).Format("HH") + "\u65F6</p>\n                </div>\n              </li>";
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    $(".tylist_date ul").html(html);
    $(".tylist_date ul li").eq(0).click();
  }
};
$(".tylist_date ul").scroll(function () {
  var visibleWidth = $(this).width();
  var totalWidth = document.querySelector(".tylist_date ul").scrollWidth;
  var maxLeft = totalWidth - visibleWidth;
  var left = $(this).scrollLeft();
  var lengthOfLi = $(this).find("li").length;
  var oneOfLi = maxLeft / lengthOfLi;
  var n = Math.ceil(left / oneOfLi);
  $(".tylist_date ul li").eq(n).click();
});

var similarTyLayer = {};
var drawSimilayTy = function drawSimilayTy(tyid, res) {
  removeForecastTyphoonLayer(tyid, "BABJ");
  removeForecastTyphoonLayer(tyid, "BCGZ");
  removeForecastTyphoonLayer(tyid, "RJTD");
  removeForecastTyphoonLayer(tyid, "ECMF");
  if (similarTyLayer[tyid]) {
    map.removeLayer(similarTyLayer[tyid]);
    delete similarTyLayer[tyid];
  }

  if (!res) {
    return;
  }
  if (typeof res === 'string') {
    res = JSON.parse(res);
  }
  var json = {
    tsid: tyid,
    intlid: res.info && res.info[0] ? res.info[0].intlid : null,
    tscname: res.info && res.info[0] && res.info[0].info && res.info[0].info.cname ? res.info[0].info.cname : null,
    tsename: res.info && res.info[0] && res.info[0].info && res.info[0].info.ename ? res.info[0].info.ename : null,
    real: [],
    fst: []
  };

  if (res.real && Array.isArray(res.real)) {
    res.real.sort(function (a, b) {
      return a.datetime - b.datetime;
    });
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = res.real[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var el = _step4.value;

        var real = formartTyphData(el);
        json.real.push(real);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  }

  if (res.forecast && Array.isArray(res.forecast)) {
    res.forecast.sort(function (a, b) {
      return a.leadtime - b.leadtime;
    });
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = res.forecast[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var opt = _step5.value;

        if (!opt.location.lon || !opt.location.lat) continue;
        var fst = formartTyphData(opt);
        json.fst.push(fst);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  }
  console.log("drawTy", json);
  var lyGp = helper.drawTy(json);

  if (lyGp) {
    similarTyLayer[tyid] = lyGp.tyLayerGroup;
    map.addLayer(similarTyLayer[tyid]);
    lyGp.layersGoesBack.map(function (el) {
      el.layer.bringToBack();
    });

    var tyReal = json.real,
        realLen = tyReal.length;
    var point = [tyReal[realLen - 1].lat, tyReal[realLen - 1].lon];
    map.setView(point, 6);
  }
};
$(".tylist_date").on("click", "li", function () {
  $(this).addClass("on").siblings("li").removeClass("on");
  var tsid = Number($("#tylistName li.on").attr("tsid"));
  var time = $(this).attr("time");
  var type = $(this).data("type");

  if (type === "real") {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = typhoonInfo[tsid].real[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var item = _step6.value;

        if (item.time == time) {
          $("#tyTsid").text(typhoonInfo[tsid].intlid);
          $("#tyLongitude").text("东经" + item.lon.toFixed(1) + "°");
          $("#tyLatitude").text("北纬" + item.lat.toFixed(1) + "°");
          $("#tyWindpower").text((0, _wind.getVelLevel)(item.ws) + "级");
          $("#tyWindspeed").text(item.ws + "(m/s)");
          $("#tyCenterpressure").text(item.ps + "(hpa)");
          $("#tySevencircle").text(item.rr07 === null ? "无" : item.rr07 + "km");
          $("#tyTencircle").text(item.rr10 === null ? "无" : item.rr10 + "km");
          break;
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  } else {
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = typhoonInfo[tsid].fst[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var _item2 = _step7.value;

        if (_item2.time + _item2.leadtime * 60 * 60 * 1000 == time) {
          $("#tyTsid").text(typhoonInfo[tsid].intlid);
          $("#tyLongitude").text("东经" + _item2.lon.toFixed(1) + "°");
          $("#tyLatitude").text("北纬" + _item2.lat.toFixed(1) + "°");
          $("#tyWindpower").text((0, _wind.getVelLevel)(_item2.ws) + "级");
          $("#tyWindspeed").text(_item2.ws + "(m/s)");
          $("#tyCenterpressure").text(_item2.ps + "(hpa)");
          $("#tySevencircle").text(_item2.rr07 === null ? "无" : _item2.rr07 + "km");
          $("#tyTencircle").text(_item2.rr10 === null ? "无" : _item2.rr10 + "km");
          break;
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }
  }
});

$(".typhoonList, #tylistReturn").on("click", function () {
  if (!$(".drawer").hasClass("a")) {
    $(".tylist_content").toggle();
  }
});
$(".typhoonList").click(function () {
  $("#tylistName ul li").eq(0).click();
  $(".tylist_date ul li").eq(0).click();
  if ($(".simiMatch").hasClass("on")) $(".closeSimi").click();
  if ($(".early_warn").hasClass("on")) (0, _typhoonDom.hidePreWarnPopup)();
  if ($(".cloudMap ul li:nth-child(1).on").length) $(".cloudMap ul li.on").eq(0).click();
  if ($(".imgEx").hasClass("on")) $(".imgEx.on").click();
  if ($(".cloudMap ul li:nth-child(2) img").hasClass("on")) $(".cloudMap ul li:nth-child(2) img.on").click();
  var $target = $(".cloudMap ul li").eq(0);
  if ($target.hasClass("on")) {
    $target.removeClass("on");
    $target.find("img").removeClass("on");
    var url = $target.find("img").data("url").replace("_pre", "");
    $target.find("img").attr("src", url);
  }
  $(".scrollbar").scrollLeft(0);
});

var initHelper = function initHelper() {
  return new Promise(function (resolve, reject) {
    if (!window.positionCenter.length) {
      var int = setInterval(function () {
        if (window.positionCenter.length) {

          helper = new _ZmapHelper.ZmapHelper(map, window.positionCenter, fcidColor.BABJ);
          clearInterval(int);
          resolve();
        }
      }, 100);
    } else {
      helper = new _ZmapHelper.ZmapHelper(map, window.positionCenter, fcidColor.BABJ);
      resolve();
    }
  });
};

function formartTyphData(opt) {
  return {
    time: opt.datetime,
    datetime: new Date(opt.datetime).Format("yyyy/MM/dd HH:mm:ss"),
    leadtime: opt.leadtime || null,
    level: opt.elements.tcrank,
    lon: opt.location.lon,
    lat: opt.location.lat,
    ps: opt.elements.pressure,
    ws: opt.elements.windspeed,
    rr06: opt.elements.rr06 || null,
    rr07: opt.elements.rr07 || null,
    rr08: opt.elements.rr08 || null,
    rr10: opt.elements.rr10 || null
  };
}

var getTyphData = function getTyphData(tsid, fcid) {
  var url = "";
  if (currentTyIds.indexOf(tsid) != -1) {
    url = window.PAGE_CONFIG.BASE_URL + "/typhoon/findForecastReal?tsid=" + tsid + "&fcid=" + fcid + "&_=" + Date.now();
  } else {
    url = window.PAGE_CONFIG.BASE_URL + "/typhoon/findForecastReal?tsid=" + tsid + "&fcid=" + fcid + "&_=" + Date.now();
  }
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: url
    }).then(function (res) {
      var json = _extends({}, typhoonInfo[tsid], {
        real: [],
        fst: []
      });
      if (res.real && Array.isArray(res.real)) {
        res.real.sort(function (a, b) {
          return a.datetime - b.datetime;
        });
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = res.real[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var el = _step8.value;

            var real = formartTyphData(el);
            json.real.push(real);
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
      if (res.forecast && Array.isArray(res.forecast)) {
        res.forecast.sort(function (a, b) {
          return a.leadtime - b.leadtime;
        });
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = res.forecast[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var opt = _step9.value;

            if (!opt.location.lon || !opt.location.lat) continue;
            var fst = formartTyphData(opt);
            json.fst.push(fst);
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      }

      typhoonInfo[tsid] = json;
      resolve(json);
    });
  });
};

var getForecastTyphData = function getForecastTyphData(tsid, fcid) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: window.PAGE_CONFIG.BASE_URL + "/typhoon/findForecastReal?tsid=" + tsid + "&fcid=" + fcid + "&_=" + Date.now()
    }).then(function (res) {
      var json = _extends({}, typhoonInfo[tsid], {
        fst: []
      });
      if (res.forecast && Array.isArray(res.forecast)) {
        res.forecast.sort(function (a, b) {
          return a.leadtime - b.leadtime;
        });
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = res.forecast[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var opt = _step10.value;

            if (!opt.location.lon || !opt.location.lat) continue;
            var fst = formartTyphData(opt);
            json.fst.push(fst);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }
      }

      typhoonInfo[tsid] = json;
      resolve(json);
    });
  });
};

function computeDistance(lng1, lat1, lng2, lat2) {
  return Math.floor(L.latLng(lat1, lng1).distanceTo(L.latLng(lat2, lng2)) / 100) / 10;
}

var helperBj = function helperBj(color) {
  return new _ZmapHelper.ZmapHelper(map, window.positionCenter, color, true);
};

var typhoonLayersFst = {};

var tyRealFcid = "BABJ";
var drawForecastTyphoon = function drawForecastTyphoon(tsid, address, ele) {
  setTimeout(function () {
    getForecastTyphData(tsid, address).then(function (data) {
      if (data.fst.length == 0) {
        return;
      }
      var mapLineColor = void 0;
      switch (address) {
        case "BCGZ":
          mapLineColor = helperBj(fcidColor.BCGZ);
          break;
        case "RJTD":
          mapLineColor = helperBj(fcidColor.RJTD);
          break;
        case "ECMF":
          mapLineColor = helperBj(fcidColor.ECMF);
          break;
        default:
          mapLineColor = helperBj(fcidColor.BABJ);
          break;
      }
      var tyLayer = mapLineColor.drawTy(data, address === tyRealFcid, address === "BABJ");
      var key = tsid + "-" + address;
      typhoonLayersFst[key] = tyLayer.tyLayerGroup;

      var tyReal = data.real,
          realLen = tyReal.length;
      var lastReal = tyReal[realLen - 1];
      var lat = lastReal.lat;
      var lon = lastReal.lon;
      if (lon && lat) {
        map.setView([lat, lon], 6);
      }
    });
  }, 500);
};
var removeForecastTyphoonLayer = function removeForecastTyphoonLayer(tsid, address) {
  var key = tsid + "-" + address;
  if (typhoonLayersFst[key]) {
    map.removeLayer(typhoonLayersFst[key]);
    delete typhoonLayersFst[key];
  }
};

var helperRj = new _ZmapHelper.ZmapHelper(map, window.positionCenter, fcidColor.RJTD, true);
var typhoonLayersFstRJ = {};
var drawForecastTyphoonRJ = function drawForecastTyphoonRJ(tsid, RJTD) {};
var removeForecastTyphoonLayerRj = function removeForecastTyphoonLayerRj(tsid, RJTD) {
  var key = tsid + "-" + "RJTD";
  if (typhoonLayersFstRJ[key]) {
    map.removeLayer(typhoonLayersFstRJ[key]);
    delete typhoonLayersFstRJ[key];
  }
};

var helperec = new _ZmapHelper.ZmapHelper(map, window.positionCenter, fcidColor.ECMF, true);
var typhoonLayersFstec = {};
var drawForecastTyphoonec = function drawForecastTyphoonec(tsid, ECMF) {};
var removeForecastTyphoonLayerec = function removeForecastTyphoonLayerec(tsid, ECMF) {
  var key = tsid + "-" + "ECMF";
  if (typhoonLayersFstec[key]) {
    map.removeLayer(typhoonLayersFstec[key]);
    delete typhoonLayersFstec[key];
  }
};

var init = [function () {
  $(".publishList span").eq(1).click();
}, function () {
  $(".publishList span").eq(2).click();
}, function () {
  $(".publishList span").eq(3).click();
}];

function debounce(fn) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  var timeout = null;

  return function () {
    var _this = this,
        _arguments = arguments;

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      fn.apply(_this, _arguments);
    }, interval);
  };
}

var cuurentytyhtml = "";
var getTyphoon = function getTyphoon(data) {
  var len = data.length;

  var _loop = function _loop(i) {
    tyLayerGroup.push("");

    var tyLength = tyLayerGroup.length;
    var name = getRankByLevel(data[i].tcrank);
    var target = $("#tyChange li:nth-child(" + tyLength + ")"),
        targetChild = $("#tyChange li:nth-child(" + tyLength + ") a");
    targetChild.text((data[i].intlid ? data[i].intlid : "") + (data[i].info.cname === "未命名" ? name : data[i].info.cname)).attr("tsid", data[i].tsid).attr("intlid", data[i].intlid);

    target.on("click", function (e) {
      $("#tyChangeWraperBg").css("display", "block");
      setTimeout(function () {
        $("#tyChangeWraperBg").css("display", "none");
      }, 500);
      e.stopPropagation();
      for (var _i = init.length - 1; _i >= 0; --_i) {
        var fn = init[_i];
        init.splice(_i, 1);
        setTimeout(fn, 1000);
      }
      var tsid_juli = $("#tyChange li").eq(i).find("a").attr("tsid");
      var fcid = "BABJ";
      getTyphData(tsid_juli, fcid).then(function (data) {

        var realPoints = data.real;

        cuurentytyhtml += "<li value='" + data.tsid + "'>" + data.tscname + "</li>";
        $(".currentyphooname").html(cuurentytyhtml);

        $('.currentyphooname li').click(function (e) {
          $(".currentyphooname li").removeClass('selectLi');
          $(this).toggleClass('selectLi');
          console.log('selectLi', $(this).attr("value"));
          var tsid_juli = $(this).attr("value");
          var fcid = "BABJ";
          getTyphData(tsid_juli, fcid).then(function (data) {
            var realPoints = data.real;

            var cityhtml = "";
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
              for (var _iterator13 = _typhoonCities2.default[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                var item = _step13.value;

                var rangedata = computeDistance(item.lon, item.lat, realPoints[realPoints.length - 1].lon, realPoints[realPoints.length - 1].lat);
                cityhtml += "\n          <ul class=\"infolist\">\n          <li>" + item.city + "</li>\n          <li>" + item.lon.toFixed(2) + "</li>\n          <li>" + item.lat.toFixed(2) + "</li>\n          <li>" + rangedata + "</li>\n          </ul>\n          ";
                $(".citylist").html(cityhtml);
              }
            } catch (err) {
              _didIteratorError13 = true;
              _iteratorError13 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }
              } finally {
                if (_didIteratorError13) {
                  throw _iteratorError13;
                }
              }
            }
          });
        });
        $('.currentyphooname li').eq(0).click();
      });

      var intlid = target.find("a").attr("intlid");
      var tsid = target.find("a").attr("tsid");
      var publishSelected = $(".publish_selected");

      console.log("台-----publishSelected", publishSelected);
      var isSelect = true;
      if (target.hasClass("layer-selected")) {
        isSelect = false;

        var _iteratorNormalCompletion14 = true;
        var _didIteratorError14 = false;
        var _iteratorError14 = undefined;

        try {
          for (var _iterator14 = publishSelected[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var item = _step14.value;

            removeTyphoonLayer(tsid, $(item).data("fcid"));
          }
        } catch (err) {
          _didIteratorError14 = true;
          _iteratorError14 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion14 && _iterator14.return) {
              _iterator14.return();
            }
          } finally {
            if (_didIteratorError14) {
              throw _iteratorError14;
            }
          }
        }

        removeForecastTyphoonLayer(tsid, "BABJ");
        removeForecastTyphoonLayer(tsid, "BCGZ");
        removeForecastTyphoonLayer(tsid, "RJTD");
        removeForecastTyphoonLayer(tsid, "ECMF");
        drawSimilayTy(tsid);
      } else {
        if (!publishSelected.length) {
          return;
        }

        var windId = $("#tyChange").find("a").attr("tsid");
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;

        try {
          var _loop2 = function _loop2() {
            var item = _step15.value;

            var fcid = $(item).data("fcid");

            if (tsid != windId) {
              var url = window.PAGE_CONFIG.BASE_URL + "/typhoon/findForecastReal?fcid=BABJ&tsid=" + tsid;
              $.ajax({
                url: url
              }).then(function (data) {
                drawSimilayTy(tsid, data);
              });
            } else {
              setTimeout(function () {
                console.log("targetclick", fcid);
                if (fcid === "ECMF") drawForecastTyphoon(tsid, "ECMF");
                if (fcid === "BABJ") drawForecastTyphoon(tsid, "BABJ");
                if (fcid === "BCGZ") drawForecastTyphoon(tsid, "BCGZ");
                if (fcid === "RJTD") drawForecastTyphoon(tsid, "RJTD");
              }, 300);
            }
          };

          for (var _iterator15 = publishSelected[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            _loop2();
          }
        } catch (err) {
          _didIteratorError15 = true;
          _iteratorError15 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion15 && _iterator15.return) {
              _iterator15.return();
            }
          } finally {
            if (_didIteratorError15) {
              throw _iteratorError15;
            }
          }
        }

        cuurentytyhtml = "";
        $(".simityList,.imgEx").show();
      }
      target.toggleClass("layer-selected");

      $(".typhoonlist .historylistitem").each(function (index, element) {
        var hisId = $(this).attr("tsid");
        if (hisId == tsid) {
          if (isSelect) {
            $(this).find("li .check_img").removeClass("his_check");
            $(this).find("li .un_check_round").addClass("his_check");
            $(this).addClass("historylist_on");
          } else {
            $(this).find("li .check_img").addClass("his_check");
            $(this).find("li .un_check_round").removeClass("his_check");
            $(this).removeClass("historylist_on");
          }
        }
      });
    });
  };

  for (var i = 0; i < len; i++) {
    _loop(i);
  }
  $(".publishList span").on("click", function () {
    var address = $(this).attr("data-fcid");
    var layersSelected = $("#tyChangeWraper .layer-selected");
    if ($(this).hasClass("publish_selected")) {
      if ($(".publish_selected").length === 1 || address === "BABJ") {
        return;
      }
      var fcids = [];
      $(".publishList").find(".publish_selected").each(function () {
        var fcid = $(this).data("fcid");
        if (fcid !== address) {
          fcids.push(fcid);
        }
      });
      if (!layersSelected.length && fcids[0] !== "ECMF") {
        tyRealFcid = fcids[0];
      }
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = layersSelected[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var layer = _step11.value;

          var tsid = $(layer).find("a").attr("tsid");
          removeForecastTyphoonLayer(tsid, address);
          if (tyRealFcid === address) {
            removeForecastTyphoonLayer($(layer).find("a").attr("tsid"), fcids[0]);
            drawForecastTyphoon($(layer).find("a").attr("tsid"), fcids[0], this);
            tyRealFcid = fcids[0];
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }
    } else {
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = layersSelected[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var _layer = _step12.value;

          drawForecastTyphoon($(_layer).find("a").attr("tsid"), address, this);
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }
    }
    $(this).toggleClass("publish_selected");
    $(".publishList span").eq(0).addClass("publish_selected");
  });


  $("#tyswNav li").eq(0).addClass("on");
  if (!currentTyIds.length) {} else {
    currentTyIds.map(function (id, index) {
      moveView = index === 0 ? true : false;
      $("#tyChange li").map(function () {
        if ($(this).find("a").attr("tsid") == id) {
          $(this).click();
        }
      });
    });
  }
};

var getTyphoonData = function getTyphoonData() {
  currentTyIds.length = 0;
  $.ajax({
    url: latestTyUrl + "&fcid=BABJ"
  }).then(function (data) {
    console.log('222', data);
    var time = Date.now() - 12 * 60 * 60 * 1000;
    var hasUpdate = false;
    var _iteratorNormalCompletion16 = true;
    var _didIteratorError16 = false;
    var _iteratorError16 = undefined;

    try {
      for (var _iterator16 = data[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
        var info = _step16.value;

        if (info.tsid in typhoonInfo === false) {
          hasUpdate = true;
        } else {
          var tyInfo = typhoonInfo[info.tsid];
          if (tyInfo.maxtime !== info.maxtime) {
            hasUpdate = true;
          }
        }
        if (info.maxtime > time) {
          currentTyIds.push(info.tsid);
        }
        typhoonInfo[info.tsid] = {
          tsid: info.tsid,
          fcid: info.fcid,
          intlid: info.intlid ? info.intlid : "",
          tscname: info && info.info && info.info.cname ? info.info.cname : null,
          tsename: info && info.info && info.info.ename ? info.info.ename : null,
          tcrank: info.tcrank,
          maxtime: info.maxtime,
          mintime: info.mintime,
          real: [],
          fst: []
        };
        if (typhoonInfo[info.tsid].tscname === "未命名") {
          typhoonInfo[info.tsid].tscname = getRankByLevel(info.tcrank);
        }
      }
    } catch (err) {
      _didIteratorError16 = true;
      _iteratorError16 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion16 && _iterator16.return) {
          _iterator16.return();
        }
      } finally {
        if (_didIteratorError16) {
          throw _iteratorError16;
        }
      }
    }

    if (!hasUpdate) {
      return;
    }

    if ($("#tyChangeWraper .layer-selected").length) {
      $("#tyChangeWraper .layer-selected").each(function () {
        $(this).click();
      });
      $("#simTyphoon ul li.simSelected").each(function () {
        $(this).click();
      });
    }

    window.currentTyNum = currentTyIds.length;

    if (!currentTyIds.length) {
      window.fstAreas = false;
      window.map.setView([window.locationInfo.lat, window.locationInfo.lon]);
      $(".drawer").addClass("a");
      $(".typhoonNoData").html("当前南海和西太平洋无台风").show();
      $(".mainCityRanging,.tySimilar,.typhoonList li").on("click", function () {
        $(".notyphoon_tip").show();
        $(".icon .close").click(function () {
          $(".notyphoon_tip").fadeOut(300);
          $(".tySimilar").find("img").attr("src", "./assets/typhone_similar@3x.png");
        });
      });
    } else {
      console.log(currentTyIds);
      var promises = currentTyIds.map(function (id) {
        return getTyphData(id, "BABJ");
      });
      Promise.all(promises).then(function (tyInfos) {
        var tyTips = "";
        var _iteratorNormalCompletion17 = true;
        var _didIteratorError17 = false;
        var _iteratorError17 = undefined;

        try {
          for (var _iterator17 = tyInfos[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
            var item = _step17.value;

            var realInfo = item.real;
            var tyLevel = realInfo[realInfo.length - 1].level;

            if (tyTips.length) {
              tyTips += "<br>";
            }

            var tyInfo = typhoonInfo[item.tsid];
            var name = tyInfo.tscname.length ? tyInfo.tscname : getRankByLevel(tyInfo.tcrank);
            tyTips += (tyInfo.intlid && tyInfo.intlid.length ? tyInfo.intlid + "号台风" : "") + " " + name;
          }
        } catch (err) {
          _didIteratorError17 = true;
          _iteratorError17 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion17 && _iterator17.return) {
              _iterator17.return();
            }
          } finally {
            if (_didIteratorError17) {
              throw _iteratorError17;
            }
          }
        }

        $(".typhoonNoData").html(tyTips).show();
      });
    }

    initHelper().then(function () {
      getTyphoon(data);
    });

    if (currentTyIds.length) {
      $(".typhoonList").show();
      $(".simityList,.imgEx").show();
      renderTyDOM();
    }
  });
};
getTyphoonData();

setInterval(function () {
  getTyphoonData();
  addWarningSignals();
}, 10 * 60000);

var typhoonLayers = {};
var drawTyphoon = function drawTyphoon(tsid, fcid) {
  getTyphData(tsid, fcid).then(function (data) {
    if (fcid === "BABJ") {
      var tyLayer = helper.drawTy(data, true);
      var key = tsid + "-" + fcid;
      typhoonLayers[key] = tyLayer.tyLayerGroup;
    }

    var tyReal = data.real,
        realLen = tyReal.length;
    var lastReal = tyReal[realLen - 1];
    var lat = lastReal.lat;
    var lon = lastReal.lon;
    if (lon && lat) {
      map.setView([lat, lon], 4);
    }
  });
};
var removeTyphoonLayer = function removeTyphoonLayer(tsid, fcid) {
  var key = tsid + "-" + fcid;
  if (typhoonLayers[key]) {
    map.removeLayer(typhoonLayers[key]);
    delete typhoonLayers[key];
  }
};

function compare(c) {
  return function (m, n) {
    var a = m[c];
    var b = n[c];
    return b - a;
  };
}
var historyArr = [];
var signalMarkers = [];
var addWarningSignals = function addWarningSignals() {
  removeWarningSignals();
  var url = window.PAGE_CONFIG.BASE_URL + "/gzh/data/warningInfo/get";
  $.ajax({
    url: url
  }).then(function (data) {

    var datashantou = data.tagObject.filter(function (item) {
      return item.status === "ON" && window.locationInfo.city.includes(item.city);
    }).sort(compare("datetime"));
    var arr = [];
    var obj = null;

    var _iteratorNormalCompletion18 = true;
    var _didIteratorError18 = false;
    var _iteratorError18 = undefined;

    try {
      for (var _iterator18 = datashantou.entries()[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
        var _step18$value = _slicedToArray(_step18.value, 2),
            index = _step18$value[0],
            i = _step18$value[1];

        if (obj || !window.locationInfo.city.includes(i.county)) {
          arr.push(i);
        } else {
          obj = i;
        }
      }
    } catch (err) {
      _didIteratorError18 = true;
      _iteratorError18 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion18 && _iterator18.return) {
          _iterator18.return();
        }
      } finally {
        if (_didIteratorError18) {
          throw _iteratorError18;
        }
      }
    }

    obj && Object.keys(obj).length && arr.unshift(obj);
    datashantou = JSON.parse(JSON.stringify(arr));
    var list = datashantou.slice(0, 3);
    if (list.length) {
      var warningSignalshtml = "";
      $.each(list, function (i) {
        warningSignalshtml += " \n          <li class='latterthree'>\n            <div class=\"panner\">\n                <div class=\"singnalevl\">\n                    <img src=\"" + list[i].info.img + "\">\n                </div>\n                <div class=\"city\">" + list[i].county + "</div>\n            </div>\n          </li>\n        ";
        $(".waringsingnals").html(warningSignalshtml + '<li class="more"><div class="panner"><div class="singnalevl"><img src="./assets/more.png"></div><div class="city">更多</div></div></li>');

        var li = document.querySelectorAll(".waringsingnals .latterthree");
        for (var j = 0; j < li.length; j++) {
          li[j].index = j;
          $(".waringsingnals .latterthree").on("click", function () {
            var info = list[this.index].info;
            var popupText = list[this.index].county + "<br>" + new Date(list[this.index].datetime).Format("yyyy年MM月dd日 HH时mm分") + "发布" + info.name;
            if (info.guide && info.guide.length) {
              popupText += "<br>防御指南";
              for (var n = 0; n < info.guide.length; n++) {
                popupText += "<br>" + (n + 1) + "\u3001" + info.guide[n];
              }
            }
            $(".defense_measure span").html(popupText);
            $(".defense_measure").fadeIn(300);
          });
        }
        if (datashantou.length <= 3) {
          $(".waringsingnals .more").css("display", "none");
        } else {
          $(".waringsingnals .more").css("display", "block");
        }

        $(".waringsingnals .more").on("click", function () {
          var moreinfo = datashantou.slice(3);
          var moreinfohtml = "";
          $.each(moreinfo, function (i) {
            moreinfohtml += "\n            <li class='moreinfo'>\n            <div class=\"moreinfoItem\">\n            <img src=\"" + moreinfo[i].info.img + "\">\n            </div>\n            <div class='committime'><a style=\"color:#58cdc6\">" + moreinfo[i].county + "</a>" + new Date(moreinfo[i].datetime).Format("yyyy年MM月dd日 HH时mm分") + "\u53D1\u5E03" + moreinfo[i].info.name + "</div></li>\n            ";
            $(".defense_measure span").html("<h2>其他预警信息</h2>" + moreinfohtml);
            $(".defense_measure").fadeIn(300);
          });
        });
      });
    }
  });
};

var removeWarningSignals = function removeWarningSignals() {
  if (signalMarkers.length) {
    var _iteratorNormalCompletion19 = true;
    var _didIteratorError19 = false;
    var _iteratorError19 = undefined;

    try {
      for (var _iterator19 = signalMarkers[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
        var item = _step19.value;

        map.removeLayer(item);
      }
    } catch (err) {
      _didIteratorError19 = true;
      _iteratorError19 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion19 && _iterator19.return) {
          _iterator19.return();
        }
      } finally {
        if (_didIteratorError19) {
          throw _iteratorError19;
        }
      }
    }

    signalMarkers.length = 0;
  }
};

addWarningSignals();
$(".bg_mask").on("click", function () {
  $(".defense_measure").fadeOut(300);
});

var getRankByLevel = function getRankByLevel(level) {
  var v = level.replace(/\s+/g, "").toUpperCase();
  v = v.substring(0, 5);
  switch (v) {
    case "TD":
      return "热带低压";
    case "TS":
      return "热带风暴";
    case "STS":
      return "强热带风暴";
    case "TY":
      return "台风";
    case "STY":
      return "强台风";
    case "SUPER":
    case "SUPER TY":
      return "超强台风";
    default:
      return "热带低压";
  }
};

function formatDate(needTime) {
  var time = new Date(needTime);
  var y = time.getFullYear();
  return y;
}

function add0(m) {
  return m < 10 ? "0" + m : m;
}

function formymd(needTime) {
  var time = new Date(needTime);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();

  return y + "-" + add0(m) + "-" + add0(d);
}

var currentTime = Date.parse(new Date());
$.ajax({
  url: window.PAGE_CONFIG.BASE_URL + "/typhoon/info/find_Latest_ByMaxtime?fcid=BABJ&limit=-1"
}).then(function (data) {
  var arr = [];

  $.each(data, function (i) {
    var Timestamp = data[i].mintime;
    var year = formatDate(Timestamp);

    if (!isNaN(year)) {
      arr.push(year);
    }
  });

  var unique = Array.from(new Set(arr));
  var obj = {};
  year = unique[0];

  var _loop3 = function _loop3(i) {
    obj[unique[i]] = data.filter(function (item) {
      var year = formatDate(item.mintime);
      return year === unique[i];
    });
  };

  for (var i = 0; i < unique.length; i++) {
    _loop3(i);
  }
  var htmlyear = "";
  unique.map(function (item) {
    htmlyear += "<li>" + item + "\u5E74</li>";
    $(".onlist").html(htmlyear);
    $(".onlist li").eq(0).addClass("year_active");
  });

  function renderhistoty(redenyear) {
    var currentyear = obj[redenyear] || [];

    var filterCurrentyear = [];
    $.each(currentyear, function (i) {
      filterCurrentyear.push(currentyear[i]);
    });
    var htmlfilterCurrentyear = "";
    filterCurrentyear.map(function (item, index) {
      var noNuber = item.intlid == null || "" ? "****" : item.intlid;

      htmlfilterCurrentyear += "\n        <ul class=\"historylistitem\" tsid=" + item.tsid + ">\n          <li> \n          <img src=\"./assets/check.png\" class=\"check_img his_check\">\n          <span class=\"un_check_round\"></span>\n          " + noNuber + " " + item.info.cname + " " + item.info.ename + "\n          </li>\n          </ul>\n      ";
    });
    $(".typhoonlist").html(htmlfilterCurrentyear);
  }

  var year = unique[0];
  renderhistoty(year);

  $(".onlist").on("click", function (e) {

    $(this).removeClass("yearlistdown");
    $(".arrows").removeClass("arrowsDown");
    $(".clickyear").text(e.target.innerHTML);
    if (e.target.tagName == "LI") {
      var redenyear = e.target.innerHTML.replace(/年/g, "");
      renderhistoty(redenyear);
    }
    $(".onlist li").each(function (index, element) {
      if (e.target.innerHTML == element.innerHTML) {
        $(".onlist li").eq(index).addClass("year_active");
      } else {
        $(".onlist li").eq(index).removeClass("year_active");
      }
    });
    console.log("year_active", historyArr);

    var selTyChangeTyids = [];
    $("#tyChange li").each(function (index, element) {
      var tsid = $(this).find("a").attr("tsid");
      if ($(this).hasClass("layer-selected")) {
        selTyChangeTyids.push(Number(tsid));
      }
    });
    $(".typhoonlist .historylistitem").each(function (index, element) {
      var hisId = $(this).attr("tsid");
      var isSelect = [].concat(selTyChangeTyids, _toConsumableArray(historyArr)).find(function (el) {
        return el == hisId;
      });

      if (isSelect) {
        $(this).addClass("historylist_on");
        $(this).find("li .check_img").removeClass("his_check");
        $(this).find("li .un_check_round").addClass("his_check");
      } else {
        $(this).find("li .check_img").addClass("his_check");
        $(this).find("li .un_check_round").removeClass("his_check");
        $(this).removeClass("historylist_on");
      }
    });
  });

  var removeAllSimTy = function removeAllSimTy() {
    console.log("similarTyLayer", similarTyLayer);
    for (var i in similarTyLayer) {
      map.removeLayer(similarTyLayer[i]);
    }similarTyLayer = {};
    for (var _i2 in typhoonInfo) {
      var ele = typhoonInfo[_i2];
      removeForecastTyphoonLayer(ele.tsid, "BABJ");
      removeForecastTyphoonLayer(ele.tsid, "BCGZ");
      removeForecastTyphoonLayer(ele.tsid, "RJTD");
      removeForecastTyphoonLayer(ele.tsid, "ECMF");
    }
    if (currentTyIds.length == 1) {
      for (var index = 0; index < currentTyIds.length; index++) {
        var _ele = currentTyIds[index];
        removeForecastTyphoonLayer(_ele, "BABJ");
        removeForecastTyphoonLayer(_ele, "BCGZ");
        removeForecastTyphoonLayer(_ele, "RJTD");
        removeForecastTyphoonLayer(_ele, "ECMF");
      }
    }
  };

  $(".historyTyphone").on("click", function () {
    if ($(this).hasClass("on")) {
      $(".historycusDetales").show();

      $("#tyChange li").each(function (index, element) {
        var tsid = $(this).find("a").attr("tsid");
        if ($(this).hasClass("layer-selected")) {
          $(".typhoonlist .historylistitem").each(function (index, element) {
            if ($(this).attr("tsid") == tsid) {
              $(this).addClass("historylist_on");
              $(this).find("li .check_img").removeClass("his_check");
              $(this).find("li .un_check_round").addClass("his_check");
            }
          });
        }
      });
    } else {
      $(".historycusDetales").hide();
    }
  });

  $(".typhoonlist").on("click", "ul", function (e) {
    var e = e || window.event;
    var img = e.target.querySelector(".check_img");
    $(img).toggleClass("his_check");
    var round = e.target.querySelector(".un_check_round");
    $(round).toggleClass("his_check");
    $(this).toggleClass("historylist_on");
    var tyid = Number($(this).attr("tsid"));
    console.log("similarTyLayer", similarTyLayer, tyid);

    if ($(this).hasClass("historylist_on")) {
      historyArr.push(tyid);
      historyArr = [].concat(_toConsumableArray(new Set(historyArr)));
      $("#tyChange li").each(function (index, element) {
        var tsid = $(this).find("a").attr("tsid");
        if (tsid == tyid) {
          $(this).addClass("layer-selected");
        }
      });
      var url = window.PAGE_CONFIG.BASE_URL + "/typhoon/findForecastReal?fcid=BABJ&tsid=" + tyid;
      $.ajax({
        url: url
      }).then(function (data) {
        if (data) {
          drawSimilayTy(tyid, data);
        }
      });
    } else {
      var index = historyArr.indexOf(tyid);
      index !== -1 && historyArr.splice(index, 1);
      $("#tyChange li").each(function (index, element) {
        var tsid = $(this).find("a").attr("tsid");
        if (tsid == tyid) {
          $(this).removeClass("layer-selected");
        }
      });
      drawSimilayTy(tyid);
    }
  });

  $(".history_close").click(function () {
    var tyid = [];
    $("#tyChange li").removeClass("layer-selected");

    var _loop4 = function _loop4(key) {
      $("#tyChange li").each(function (index, element) {
        var tsid = $(this).find("a").attr("tsid");
        if (key === tsid) {
          $("#tyChange li:nth-child(" + (index + 1) + ")").addClass("layer-selected");
        }
      });
    };

    for (var key in similarTyLayer) {
      _loop4(key);
    }
  });
});

if (currentTyIds.length) {
  window.setPositionCenter([115.89, 28.68]);
}


//////////////////
// WEBPACK FOOTER
// ./js/typhoon.js
// module id = 20
// module chunks = 0